import { useGetEmploymentType } from '@entities/employmentType';
import type { SelectProps } from '@mantine/core';
import { FormSelect } from '@shared/ui';

type CandidateEmploymentTypesSelectProps = Pick<
  SelectProps,
  'onChange' | 'value'
>;

export const CandidateEmploymentTypesSelect = ({
  value,
  onChange,
}: CandidateEmploymentTypesSelectProps) => {
  const { data: employmentTypes, isError, isLoading } = useGetEmploymentType();

  return (
    <FormSelect
      variant='column'
      title='Тип занятости'
      description=''
      aria-label='Тип занятости'
      placeholder='Все'
      data={employmentTypes?.map(type => ({
        label: type.name,
        value: type.id.toString(),
      }))}
      disabled={isLoading || isError}
      value={value}
      onChange={onChange}
      containerProps={{ gap: 4, flex: 1 }}
    />
  );
};
